"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureUsageEventV2 = void 0;
var Enum_1 = require("../utils/Enum");
/**
 * FeatureUsageEventV2 is used to populate heart-metrics related data
 * featureName - Name of the functionality
 * subFeatureName - Sub feature name
 * actionName - actionName like create/rupdate etc
 * eventName - Is a Enum (EventName)
 * actionType - Is a Enum (ActionType)
 * componentType - Is a Enum (ComponentType)
 * componentUri -
 * userRoleName - Logged in user role name
 * entityId - The reference id of the operation for ex: orderId/transactionId
 * templateType - This is for Internal use, field used to identify the model
 * startDateTime - Event start DateTime
 * endDateTime - Event end DateTime
 * experienceResult - Task sucess or failure
 * experimentationConfigId - Flighting id
 * experimentationConfigName - Flighting name
 * experimentationConfigResult -
 * capabilityType - Capability type
 * isEmbeddedExperience - Is embedded experience
 * embeddedExpereinceName - Embedded expereince name
 */
var FeatureUsageEventV2 = /** @class */ (function () {
    function FeatureUsageEventV2(featureName, actionType, actionName, eventName, componentType) {
        this.featureName = featureName;
        this.actionName = actionName;
        this.eventName = eventName;
        this.actionType = actionType;
        this.componentType = componentType;
        this.eventType = Enum_1.ItEventType.FeatureUsageEvent;
    }
    Object.defineProperty(FeatureUsageEventV2.prototype, "TaskName", {
        get: function () {
            return this.taskName;
        },
        set: function (value) {
            this.taskName = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureUsageEventV2.prototype, "TaskStatus", {
        get: function () {
            return this.taskStatus;
        },
        set: function (value) {
            this.taskStatus = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureUsageEventV2.prototype, "ActionStatus", {
        get: function () {
            return this.actionStatus;
        },
        set: function (value) {
            this.actionStatus = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureUsageEventV2.prototype, "CapabilityType", {
        get: function () {
            return this.capabilityType;
        },
        set: function (value) {
            this.capabilityType = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureUsageEventV2.prototype, "EmbeddedExpereinceName", {
        get: function () {
            return this.embeddedExpereinceName;
        },
        set: function (value) {
            this.embeddedExpereinceName = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureUsageEventV2.prototype, "IsEmbeddedExperience", {
        get: function () {
            return this.isEmbeddedExperience;
        },
        set: function (value) {
            this.isEmbeddedExperience = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureUsageEventV2.prototype, "EventName", {
        get: function () {
            return this.eventName;
        },
        set: function (value) {
            this.eventName = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureUsageEventV2.prototype, "EventType", {
        get: function () {
            return this.eventType;
        },
        set: function (value) {
            this.eventType = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureUsageEventV2.prototype, "Duration", {
        get: function () {
            return this.duration;
        },
        set: function (value) {
            this.duration = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureUsageEventV2.prototype, "FeatureName", {
        get: function () {
            return this.featureName;
        },
        set: function (value) {
            this.featureName = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureUsageEventV2.prototype, "SubFeatureName", {
        get: function () {
            return this.subFeatureName;
        },
        set: function (value) {
            this.subFeatureName = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureUsageEventV2.prototype, "ActionName", {
        get: function () {
            return this.actionName;
        },
        set: function (value) {
            this.actionName = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureUsageEventV2.prototype, "ActionType", {
        get: function () {
            return this.actionType;
        },
        set: function (value) {
            this.actionType = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureUsageEventV2.prototype, "ExperimentationConfigId", {
        get: function () {
            return this.experimentationConfigId;
        },
        set: function (value) {
            this.experimentationConfigId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureUsageEventV2.prototype, "ExperimentationConfigName", {
        get: function () {
            return this.experimentationConfigName;
        },
        set: function (value) {
            this.experimentationConfigName = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureUsageEventV2.prototype, "ExperimentationConfigResult", {
        get: function () {
            return this.experimentationConfigResult;
        },
        set: function (value) {
            this.experimentationConfigResult = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureUsageEventV2.prototype, "TemplateType", {
        get: function () {
            return "Internal.FeatureUsageEventV2";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureUsageEventV2.prototype, "ComponentType", {
        get: function () {
            return this.componentType;
        },
        set: function (value) {
            this.componentType = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureUsageEventV2.prototype, "UserRoleName", {
        get: function () {
            return this.userRoleName;
        },
        set: function (value) {
            this.userRoleName = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureUsageEventV2.prototype, "StartDateTime", {
        get: function () {
            return this.startDateTime;
        },
        set: function (value) {
            this.startDateTime = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureUsageEventV2.prototype, "EndDateTime", {
        get: function () {
            return this.endDateTime;
        },
        set: function (value) {
            this.endDateTime = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureUsageEventV2.prototype, "ComponentUri", {
        get: function () {
            return this.componentUri;
        },
        set: function (value) {
            this.componentUri = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureUsageEventV2.prototype, "EntityId", {
        get: function () {
            return this.entityId;
        },
        set: function (value) {
            this.entityId = value;
        },
        enumerable: false,
        configurable: true
    });
    FeatureUsageEventV2.prototype.getFeatureUsageName = function (eventProperties) {
        if (eventProperties.SubFeatureName != null && eventProperties.SubFeatureName !== "" && eventProperties.SubFeatureName !== undefined)
            return eventProperties.FeatureName + "." + eventProperties.SubFeatureName + "-" + eventProperties.ActionName + "-" + eventProperties.EventName + "-" + eventProperties.ActionType;
        else
            return eventProperties.FeatureName + "-" + eventProperties.ActionName + "-" + eventProperties.EventName + "-" + eventProperties.ActionType;
    };
    FeatureUsageEventV2.prototype.IsValidEvent = function () {
        if (!this.eventName || 0 === this.eventName.length) {
            return false;
        }
        else {
            return true;
        }
    };
    return FeatureUsageEventV2;
}());
exports.FeatureUsageEventV2 = FeatureUsageEventV2;
//# sourceMappingURL=FeatureUsageEventV2.js.map